import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

/**
 * AiContext — lightweight page/entity context surfaced to the floating
 * AI Assistant. Any page can call `useAiContext().set({page, entity_type, entity_id, label})`
 * inside a useEffect and the FloatingAssistantButton will forward that to
 * /api/ai/chat so the AI can answer / propose actions scoped to the record
 * the admin is currently looking at.
 */
const AiCtx = createContext({
  context: null,
  set: () => {},
  clear: () => {},
});

export function AiContextProvider({ children }) {
  const [context, setContext] = useState(null);

  const set = useCallback((ctx) => {
    if (!ctx) return setContext(null);
    setContext({ ...ctx });
  }, []);
  const clear = useCallback(() => setContext(null), []);

  const value = useMemo(() => ({ context, set, clear }), [context, set, clear]);
  return <AiCtx.Provider value={value}>{children}</AiCtx.Provider>;
}

export function useAiContext() { return useContext(AiCtx); }
